import { filterStoreRepo } from 'components/Filters/FilterStore'
import FilterModal, {
  FilterGroup,
} from 'components/Filters/components/FilterModal'
import { DateRangeFilter } from 'components/Filters/fields/DateRangeFilter'

import { FilterIdentifier } from 'models/saved_view'
import { RangeFilter } from 'components/Filters/fields/RangeFilter'

export default function ProductsFilterset({
  filterIdentifier,
}: {
  filterIdentifier: FilterIdentifier
}) {
  const productsFilterStore = filterStoreRepo.getStore(
    filterIdentifier as FilterIdentifier
  )

  return (
    <FilterModal store={productsFilterStore} identifier={filterIdentifier}>
      <FilterGroup title="Product Metrics" className="lg:grid-cols-2">
        <RangeFilter
          filterKey="avg_serving_size_per_lb"
          title="Avg. Volume per Unit"
          store={productsFilterStore}
        />
        <RangeFilter
          filterKey="mfg_avg_list_price_per_lb"
          title="Avg. Revenue per Unit"
          store={productsFilterStore}
        />
        <RangeFilter
          filterKey="est_monthly_churn_rate"
          title="Est. Monthly Churn Rate"
          store={productsFilterStore}
        />
        <RangeFilter
          filterKey="estimated_sales_potential"
          title="Avg. Units Sold per Month"
          store={productsFilterStore}
        />
        <RangeFilter
          filterKey="variants_count"
          title="Number of Variants"
          store={productsFilterStore}
        />
      </FilterGroup>
      <FilterGroup title="Date Filters">
        <DateRangeFilter
          filterKey="created"
          title="Created Date"
          filterStore={productsFilterStore}
        />
        <DateRangeFilter
          filterKey="modified"
          title="Modified Date"
          filterStore={productsFilterStore}
        />
      </FilterGroup>
    </FilterModal>
  )
}
